import { uri } from '../api/uri'

export const initState = {
  users: [],
  clientsOnline: [],
  hostessOnline: []
}
export const state = () => {
  return {
    ...initState
  }
}
export const actions = {
  __clear ({ commit }) {
    commit('__clear')
  },
  initUsers ({ commit }, users) {
    commit('initUsers', users)
  },
  addUser ({ commit }, user) {
    commit('addUser', user)
  },
  deleteUser ({ commit }, user) {
    commit('deleteUser', user)
  },
  async selfReload ({ commit }) {
    const res = await this.$axios(uri.me)
    if (res.data && res.data.data) {
      this.$auth.setUser(res.data.data)
      this.$gates.setRoles(res.data.data.roles)
    }
  },
  setClientsOnline ({ commit }, list = []) {
    commit('setClientsOnline', list)
  },
  setHostessesOnline ({ commit }, list = []) {
    commit('setHostessesOnline', list)
  }
}
export const mutations = {
  __clear (state) {
    Object.assign(state, initState)
  },
  initUsers (state, users) {
    state.users = users
  },
  addUser (state, user) {
    state.users.push(user)
  },
  deleteUser (state, user) {
    state.users = state.users.filter((e) => {
      return e.id !== user.id
    })
  },
  setClientsOnline (state, online) {
    state.clientsOnline = Array.isArray(online) ? online : []
  },
  setHostessesOnline (state, online) {
    state.hostessOnline = Array.isArray(online) ? online : []
  }
}
export const getters = {
  users (state, getters, rootState) {
    if (rootState.auth.loggedIn) {
      const authUser = rootState.auth.user.userId
      return state.users.filter((e) => {
        return e.id !== authUser
      }) || []
    }
    return []
  },
  customersOnline (state) {
    return [...state.clientsOnline, ...state.hostessOnline]
  },
  customersOnlineCount (state) {
    return [...state.clientsOnline, ...state.hostessOnline].length || 0
  },
  clientsOnlineCount (state) {
    return state.clientsOnline.length || 0
  },
  hostessesOnlineCount (state) {
    return state.hostessOnline.length || 0
  }
}
